
export const ADD_BOOKING = "ADD_BOOKING";
export const REMOVE_BOOKING = "REMOVE_BOOKING";
